// extracted by mini-css-extract-plugin
export default {"WixMobileBackButton":"WtdqK4","wixMobileBackButton":"WtdqK4","WixMobileBackButton__icon":"_lOttJ","wixMobileBackButtonIcon":"_lOttJ"};